// @givmo/app-charity — the authenticated layout's render-free PROBES, one component for both trees
// (CPA-WEB85).
//
// The console's authenticated layout mounts three probes ABOVE `<OrgScopedBoundary>`, each for the
// reason its own file gives: `<MembershipsFreshness>` (CPA-WEB46, the memberships read's navigation
// trigger), `<OrganizationDeepLinkProbe>` (CPA-BE29, the organization deep link's decision, which the
// claim wizard's Continue follows since CPA-WEB83) and `<ClaimWizardRefreshProbe>` (CPA-WEB55, the
// refreshed list the claim wizard's entry decides on).
//
// ⚠ THE PREVIEW HARNESS MOUNTS THIS TOO, and that is why it is one component. `preview/main.tsx`
// builds its OWN route tree, and when CPA-WEB55 added the third probe to the deployed layout alone,
// the harness's claim wizard sat on its loading card for good: the entry waits on the probe's answer,
// and nothing there asked. With both layouts mounting this, a probe added here reaches both.
//
// It reads the two matched routes by their ids, as literals: the harness registers the same ids (its
// shell layout is `authenticated`, like the deployed one), and importing the route objects from
// `routes.tsx` would be a cycle.

import { useMatch } from '@tanstack/react-router';
import { ORGANIZATION_DEEP_LINK_DESTINATION_PARAM } from '../console/console-routes';
import { ClaimWizardRefreshProbe } from '../features/claim/claim-memberships-refresh';
import { MembershipsFreshness } from '../org/memberships-freshness';
import { OrganizationDeepLinkProbe } from './organization-deep-link';

/** Mounted once by each authenticated layout, under `<ActiveOrgProvider>`, above the boundary. */
export function ConsoleLayoutProbes() {
  const deepLink = useMatch({
    from: '/authenticated/organizations/$charityId',
    shouldThrow: false,
  });
  const claimWizard = useMatch({ from: '/authenticated/claim/$charityId', shouldThrow: false });
  return (
    <>
      <MembershipsFreshness />
      {/* Handed the link's raw `to` (CCM-R1-SIGN-LINK-ORG), which it vets itself: TanStack keeps an
          unknown search param as typed, so nothing upstream has. */}
      <OrganizationDeepLinkProbe
        charityId={deepLink?.params.charityId ?? null}
        destination={
          (deepLink?.search as Record<string, unknown> | undefined)?.[
            ORGANIZATION_DEEP_LINK_DESTINATION_PARAM
          ]
        }
      />
      <ClaimWizardRefreshProbe charityId={claimWizard?.params.charityId ?? null} />
    </>
  );
}
